export default {
  statusList: [{
      status: 0,
      statusName: "保存未提交",
      statusClass: "color-grey",
    },
    {
      status: 1,
      statusName: "已提交",
      statusClass: "color-grey",
    },
    {
      status: 2,
      statusName: " 审核不通过",
      statusClass: "color-red",
    },
    {
      status: 3,
      statusName: "审核通过",
      statusClass: "color-green",
    },
    {
      status: 5,
      statusName: "强制结束",
      statusClass: "color-red"
    },
    {
      status: 6,
      statusName: "驳回",
      statusClass: "color-red",
    },
  ]
}
